export interface ContractState {
  EstSansEffet: boolean;
  EstSigne: boolean;
  NumeroContrat: string;
  RefContrat?: string;
  RefDocumentCP: string;
  RefDocumentFIC: string;
  RefDocumentMandatSEPA: string;
  RefDocumentCG: string;
  RefDocumentAttestation: string;
  RefDocumentsSI: string[];
  ClientAdvisorFullName: string;
}

export const initialContractState: ContractState = {
  EstSansEffet: false,
  EstSigne: false,
  RefDocumentFIC: '',
  NumeroContrat: '',
  RefContrat: '',
  RefDocumentCP: '',
  RefDocumentMandatSEPA: '',
  RefDocumentAttestation: '',
  RefDocumentCG: '',
  RefDocumentsSI: [],
  ClientAdvisorFullName: '',
};
